import React, { FC, useEffect } from 'react';
import { useDmsState } from '@packages/contexts/dms';
import { DMSDetailContent } from '../dms-detail-content';

export const DMSPdfBody: FC = () => {
    const { selectedRepairOrder } = useDmsState();

    useEffect(() => {
        const css = '@page { margin: 0.25cm 0.25cm 1.2cm 0.25cm; }';
        const existing = document.getElementById('pdf-page-margin') as HTMLStyleElement | null;
        if (existing) {
            existing.innerHTML = css;
            return;
        }
        const style = document.createElement('style');
        style.id = 'pdf-page-margin';
        style.media = 'print';
        style.innerHTML = css;
        document.head.appendChild(style);
    }, []);

    return <DMSDetailContent latestRepairOrder={selectedRepairOrder} />;
};
